// src/jira/site/types.ts
var JiraSiteAriResourceOwner = "jira", JiraSiteAriResourceType = "site";

export {
  JiraSiteAriResourceOwner,
  JiraSiteAriResourceType
};
